import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { TherapistModel } from "./TherapistModel";

export class TherapistFindResultModel extends BaseFindResult {

    public getDataItem(i: number): TherapistModel {
        let o: TherapistModel = Object.assign(new TherapistModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): TherapistModel[] {

        let d: TherapistModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: TherapistModel = Object.assign(new TherapistModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
